import React from 'react';
import { Switch } from 'react-router-dom';
import ManageBookings from './page';
import ProtectedRoute from '../../extras/ProtectedRoute';
import AddNewBooking from './add-new-booking/page';
import SessionDetails from './session-details/page';
import SessionReview from './session-review/page';
import WatchRecording from './watch-recording/page';

export default function ManageBookingsRouter() {
  return (
    <Switch>
      <ProtectedRoute
        path='/manage-bookings'
        exact={true}
        component={ManageBookings}
      />
      <ProtectedRoute
        path='/manage-bookings/add-new-booking'
        component={AddNewBooking}
      />
      <ProtectedRoute
        path='/manage-bookings/session-details/:bookingId'
        component={SessionDetails}
      />
      <ProtectedRoute
        path='/manage-bookings/session-review/:bookingId'
        component={SessionReview}
      />
      <ProtectedRoute
        path='/manage-bookings/watch-recording/:bookingId'
        component={WatchRecording}
      />
    </Switch>
  );
}
